(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairPrizesController', PhysicalFairPrizesController)

    PhysicalFairPrizesController.$inject = ['PhysicalFairService', 'expos'];

    function PhysicalFairPrizesController(PhysicalFairService, expos) {
        var vm = this;
        vm.queryFlag                    = false;
        vm.expos                        = expos;
        vm.expoSelected                 = -1;
        vm.getPrizes                    = getPrizes;
        vm.prizes                       = [];
        vm.referrals                    = [];
        vm.winners                      = [];
        vm.randomBg                     = randomBg;
        vm.generateWinners              = generateWinners
        vm.saveWinners                  = saveWinners
        vm.hasDBWinners                 = false;

        function randomBg(){
            const backgrounds = ['emerald-bg', 'red-bg', 'yellow-bg', 'green-bg', 'purple-bg', 'gray-bg']
            return backgrounds[Math.floor(Math.random() * backgrounds.length)]
        }
        function saveWinners(){
            const payload = vm.winners.map((w) => ({
                'user_id': w.user_id,
                'expo_id': vm.expoSelected,
                'prize_id': w.prize_id
            }))
            PhysicalFairService.saveWinners(payload).then(function(response){
                vm.hasDBWinners   = true
            })
        }
        function generateWinners(){
            PhysicalFairService.generateWinners({expoId: vm.expoSelected}).then(function(response){
                vm.queryFlag    = true;
                vm.winners      = response.data
            })
        }
        function getPrizes () {
            var self = this;
            PhysicalFairService.getPrizes({expoId: vm.expoSelected}).then(function(response){
                vm.queryFlag    = true;
                vm.prizes       = response.data.map(p => ({
                    ...p,
                    bgColor: self.randomBg()
                }));
            })
            PhysicalFairService.getReferrals({expoId: vm.expoSelected}).then(function(response){
                vm.referrals = response.data;
            })
            PhysicalFairService.getWinners({expoId: vm.expoSelected}).then(function(response){
                vm.winners = response.data;
                if(vm.winners.length) vm.hasDBWinners = true
            })
        }
    }
})();